export default "__VITE_ASSET__CuOYsVz3__"